<template>
  <transition name="fadeUp">
  <div id="publishUI" v-show="isShow">
    <div class="publishUI__overlay"></div>
    <div class="publishUI__body">
      <div class="successTempSave" v-show="showState == 2">
        現状のメッセージを保存しました<span class="endLetter">。</span>
      </div>
      <transition name="fadeUp">
      <div class="confirmSave" v-show="showState == 3">
        <div class="confirmSave__text textShadow">
          <div>
            壁面に描きこむために<br />位置情報を利用します<span
              class="endLetter"
              >。</span
            >
          </div>
          <div class="note">
            ※RENGAの壁付近のみ描きこめます<span class="endLetter">。</span>
          </div>
        </div>

        <div @click="publish" class="confirmSave__button buttonPrimary">
          描きこむ
        </div>
        <div @click="cancelSave" class="textButton">
          キャンセル
        </div>
      </div>
      </transition>
      <div class="saveDialog" v-show="showState == 1">
        <div class="saveDialog__publish">
          <div class="textShadow">
            壁面に描きこみます<span class="endLetter">。</span><br />よろしいですか<span class="endLetter">？</span>
          </div>
          <div @click="confirmPublish" class="buttonPrimary">
            OK
          </div>
        </div>
        <div class="saveDialog__tmpSave">
          <div class="saveDialog__tmpSave__text textShadow">
            あとで描きこむ方はこちら
          </div>
          <div @click="saveTemp" class="button bold button--dark">
            保存
          </div>
        </div>

        <div class="saveDialog__cancel">
          <div @click="cancel" class="textButton">
            キャンセル
          </div>
        </div>
      </div>
    </div>
  </div>
  </transition>

</template>

<script>
import API from "../../api/API";
import * as StoreUtil from "../../util/StoreUtil";
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
import { checkGeo } from "../../util/GeoUtil";
import { showGPSError } from "../../modal/ModalEvent";
import * as Modal from "../../modal/ModalEvent";
import DrawingStorage from "../../api/DrawingStorage";

export default {
  name: "PublishUI",
  computed: {
    isShow() {
      return StoreUtil.isModePublish();
    }
  },
  data() {
    return {
      showState: 1
    };
  },
  mounted() {
    DrawEvent.on(drawEventType.PUBLISH_DATA, this.onPublishData);
  },
  destroyed() {
    DrawEvent.off(drawEventType.PUBLISH_DATA, this.onPublishData);
  },

  methods: {
    saveTemp() {
      if (DrawingStorage.hasOtherTmpImage(this.$store.state.concert.concertId)) {
        if (!confirm("他に一時保存されているものがあります。上書きして保存します。よろしいですか？")) {
          return;
        }
      }

      // 一時保存Save
      DrawEvent.emit(drawEventType.HISTORY_SAVE);
      this.showSuccessTemp();
    },
    confirmPublish() {
      this.showState = 3;
    },
    cancelSave() {
      this.showState = 1;
    },
    async publish() {
      StoreUtil.showLoading();
      if (this.$store.state.config.geoCheat) {
        this.emitPublish();
        return;
      }

      const geo = this.$store.state.geo;
      try {
        const result = await checkGeo(geo.thresholdKM, geo.lat, geo.lng);
        console.log("result", result);
        if (result) {
          this.emitPublish();
          // StoreUtil.hideLoading();
        }
        else {
          showGPSError();
          StoreUtil.hideLoading();
        }
      }
      catch (e) {
        showGPSError(e.err.code);
        StoreUtil.hideLoading();
      }

    },
    emitPublish() {
      DrawEvent.emit(drawEventType.PUBLISH);
    },
    onPublishData(data) {
      // APIを叩いてからGotoする
      // Canvasの画像を取得する 300x300 → API に投げる
      // SaveするやつからDrawでちっさくする
      StoreUtil.showLoading();
      API.sendMessage(
        data.data,
        this.$store.getters["tool/texts"],
        data.pos.x,
        data.pos.y
      )
        .then(
          () => {
            StoreUtil.setDrawn(true);
            StoreUtil.gotoEnd();
            DrawingStorage.removeTemp();
          },
          e => {
            if (e.message.indexOf("403") < 0)
             Modal.showAPIError("send message");
          }
        )
        .finally(() => {
          // しばらくクルクルを回しておかないと連打ができてしまうので。
          setTimeout(()=>{
            StoreUtil.hideLoading();
          }, 200)
        });
    },
    cancel() {
      StoreUtil.gotoDraw();
    },
    closeTempSave() {
      this.showState = 1;
      StoreUtil.gotoDraw();
    },
    showSuccessTemp() {
      this.showState = 2;
      setTimeout(() => {
        this.closeTempSave();
      }, 2000);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/colors"
@import "../../sass/zindex"
@import "../../sass/common"
#publishUI
    color: white
    position: absolute
    z-index: $z_header_ui
    top: 0
    left: 0
    right: 0
    bottom: 0
.publishUI__overlay
    position: absolute
    z-index: 1
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.8)
.publishUI__body
    @include bold
    position: absolute
    z-index: 10
    width: 100%
    height: 100%
    @include flexCenter
    text-align: center
    //hanging-punctuation: allow-end
    text-justify: auto
.successTempSave
  width: 100%
  @include vw(17.5)
  @include bold
.confirmSave
    width: 90%
    margin-top: -9.4em
    .confirmSave__text
        @include vw(17.5)
        line-height: 1.571428571
        margin-bottom: 1.1em
        > div:first-child
          margin-bottom: .35em
        > div:nth-child(2)
          margin-bottom: 0.0em
        .note
          font-size: 80%
    .confirmSave__button
        margin: 0 auto 1.5em

.saveDialog
    @include vw(17.5)
    .button, .buttonPrimary
        margin: auto
    .textShadow
        margin-bottom: 0.5em
.saveDialog__tmpSave
  margin-bottom: 1.3em
  //.button
    font-size: 13px
    height: 40px
    width: 165px
    border-radius: 40px
.saveDialog__tmpSave__text
    font-size: 12px
.saveDialog__publish
    margin-bottom: 2.5em
    line-height: 1.571428571
.saveDialog__cancel
  font-size: 15px
.textButton
  font-weight: normal
.fadeUp-enter-active
  transition: all .3s cubic-bezier(.02,.53,.15,1)
.fadeUp-leave-active
  transition: all .0s ease-out
.fadeUp-enter, .fadeUp-leave-to
  opacity: 0
.fadeUp-enter
  transform: translateY(15px)
</style>
